'use client';

import React, { useEffect, useState } from 'react';
import { DoctorPrice } from '@/widgets/DoctorCard';
import { useDoctor } from '../model/store';
import type { IMedcenter } from '@/entities/medcenter/model/types';
interface Props {
  medcenters: IMedcenter[];
}
export const DoctorPriceWrapper: React.FC<Props> = ({
  medcenters
}) => {
  const {
    medcenterId
  } = useDoctor();
  const [currentMedcenter, setCurrentMedcenter] = useState(medcenters[0]);
  useEffect(() => {
    if (medcenterId) {
      setCurrentMedcenter(medcenters.find(item => item.id === medcenterId)!);
    }
  }, [medcenterId]);
  return <DoctorPrice medcenter={currentMedcenter} titleClasses="text-base font-bold" priceClasses="flex flex-col gap-2.5" data-sentry-element="DoctorPrice" data-sentry-component="DoctorPriceWrapper" data-sentry-source-file="DoctorPriceWrapper.tsx" />;
};